import {
  DEFAULT_MAX_RESIZE_WIDTH,
  DEFAULT_MIN_RESIZE_WIDTH,
} from '../constants';

type CheckResizableColumnWidthLimitsArgs = {
  width: number;
  minResizeWidth?: number;
  maxResizeWidth?: number;
};

export const checkResizableColumnWidthLimits = ({
  width,
  minResizeWidth,
  maxResizeWidth,
}: CheckResizableColumnWidthLimitsArgs): number => {
  const _minResizeWidth = minResizeWidth || DEFAULT_MIN_RESIZE_WIDTH;

  if (width < _minResizeWidth) {
    return _minResizeWidth;
  }

  const _maxResizeWidth = maxResizeWidth || DEFAULT_MAX_RESIZE_WIDTH;

  if (width > _maxResizeWidth) {
    return _maxResizeWidth;
  }

  return width;
};
